import { render, staticRenderFns } from "./RenderData.vue?vue&type=template&id=681a4ef0"
import script from "./RenderData.vue?vue&type=script&lang=js"
export * from "./RenderData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports